import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // Import carousel styles
import Icons from "../../../../Config/Images";
import "./Banner.css";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import CustomLoader from "../../CustomComponents/CustomLoader/CustomLoader";

const Banner = ({ data }) => {
  const [bannerImages, setBannerImages] = useState([]);
  const [carouselKey, setCarouselKey] = useState(0); // Add key state
  const [isLoading, setIsLoading] = useState(false);

  const getIsMobile = () => window.innerWidth <= 768;
  // const processBanners = (rawData) => {
  //   const isMobile = getIsMobile();
  //   return rawData.map((item) => ({
  //     url:
  //       isMobile && item.banner_image_url_mobile
  //         ? item.banner_image_url_mobile
  //         : item.banner_image_url,
  //   }));
  // };
  const processBanners = (rawData) => {
    const isMobile = getIsMobile();
    
    return rawData
      .filter((item) => {
        // Strict: show only mobile image if on mobile, skip if null
        if (isMobile) return !!item.banner_image_url_mobile;
        return !!item.banner_image_url;
      })
      .map((item) => ({
        url: isMobile ? item.banner_image_url_mobile : item.banner_image_url,
      }));
  };

  // useEffect(() => {
  //   if (data) {
  //     setBannerImages(data);
  //   }
  // }, [data]);
  // useEffect(() => {
  //   setIsLoading(true);
  //   if (data && data?.length > 0) {
  //     setBannerImages([...data]); // Spread to trigger state update
  //     setCarouselKey((prevKey) => prevKey + 1); // Change key to force re-render
  //     setIsLoading(false);
  //   }else{
  //     setIsLoading(false);
  //   }

  // }, [data]);
  useEffect(() => {
    setIsLoading(true);
    if (data && data.length > 0) {
      const selectedImages = processBanners(data);
      setBannerImages(selectedImages);
      setCarouselKey((prevKey) => prevKey + 1); // re-render carousel
    }
    setIsLoading(false);
  }, [data]);

  return (
    <div className="banner-carousel-container">
      <Carousel
        key={carouselKey} // Force re-render on data update
        autoPlay={true}
        infiniteLoop={true}
        showThumbs={false}
        showStatus={false}
        interval={3000}
        emulateTouch
        dynamicHeight={false}
        showArrows={false} // Disable navigation arrows
        transitionTime={800}
      >
        {isLoading ? (
          <>
            <div className="loaderContainer">
              <CustomLoader />
            </div>
          </>
        ) : (
          bannerImages?.map((image, index) => (
            <div key={index} className="banner-carousel-slider">
              <CustomImageComponent
                src={image?.url}
                alt={`Banner ${index + 1}`}
                height={`100%`}
                width={`100%`}
                style={{
                  userSelect: "none",
                  WebkitUserDrag: "none",
                  WebkitUserSelect: "none",
                  MozUserSelect: "none",
                  msUserSelect: "none",
                }}
              />
              {/* <img style={{width:"100%", }} src={image?.banner_image_url} alt="" /> */}
            </div>
          ))
        )}
      </Carousel>
    </div>
  );
};

export default Banner;
